import { AppBrandLink, AppNavigation, AppNavigationHeader } from '@ms/yammer-features-app-navigation';
import { UniversalCreateButtonProvider } from '@ms/yammer-universal-create-button';
import { useCampaignCreateModal } from '@ms/yammer-web-components/dist/campaignCreateEdit/CampaignCreateModal/hooks/useCampaignCreateModal';
import { useGroupCreateModal } from '@ms/yammer-web-components/dist/groupCreateEdit/LoadableGroupCreateModal';
import NavigationCommunities from '@ms/yammer-web-components/dist/navigation/NavigationCommunities';
import { usePostCreateModal } from '@ms/yammer-web-components/dist/publisher/LoadableUniversalCreatePublisherModal';
import AutocompleteAriaHost from '@ms/yammer-web-core-ui/dist/components/AutocompleteAriaHost';
import { useIsTeamsPersonalApp } from 'hooks/selectors';
import React, { FC } from 'react';

import AppSearchNavPhase1 from '../AppSearchNavPhase1';
import { UserProfileMenuButton } from '../UserProfileMenuButton';
import VivaSuiteNav from '../VivaSuiteNav';

import { useHomeLinkActionButtons } from './hooks/useHomeLinkActionButtons';

export const DefaultLeftNav: FC = () => {
  const homeLinkActionButtons = useHomeLinkActionButtons();
  const isTeamsPersonalApp = useIsTeamsPersonalApp();
  const campaignCreateModal = useCampaignCreateModal('UniversalCreateButton');

  const vivaSuiteNav = isTeamsPersonalApp ? <VivaSuiteNav /> : null;

  return (
    <UniversalCreateButtonProvider
      useGroupCreateModal={useGroupCreateModal}
      campaignCreateModal={campaignCreateModal}
      usePostCreateModal={usePostCreateModal}
    >
      <AppNavigation
        communitiesNavLinksContent={<NavigationCommunities />}
        header={
          <AppNavigationHeader
            title={<AppBrandLink />}
            contextMenu={vivaSuiteNav}
            searchInput={
              <AutocompleteAriaHost>
                <AppSearchNavPhase1 />
              </AutocompleteAriaHost>
            }
          />
        }
        homeLinkActionButtons={homeLinkActionButtons}
        userProfileLinkActionButtons={[<UserProfileMenuButton key="UserProfileMenuButton" />]}
      />
    </UniversalCreateButtonProvider>
  );
};
